import { CANDY_APPLE, CALYPSO, KOALA, LORAX, MARIGOLD, NORMAN, OZ, SORBET, THUNDERDOME } from 'HubStyleTokens/colors';
export default {
  'candy-apple': CANDY_APPLE,
  calypso: CALYPSO,
  koala: KOALA,
  lorax: LORAX,
  marigold: MARIGOLD,
  norman: NORMAN,
  oz: OZ,
  sorbet: SORBET,
  thunderdome: THUNDERDOME
};